import { NgModule } from '@angular/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CardsModule } from 'src/app/views/cards/cards.module';
import { CarouselComponent } from 'src/app/views/carousel/carousel.component';
import { TrimOnBlurDirective } from '../common/directives/trim-on-blur/trim-on-blur.directive';
import { PipesModule } from '../common/pipes/pipes.module';
import { BreadcrumbNavigationComponent } from '../components/navigation/breadcrumb-navigation/breadcrumb-navigation.component';
import { OrganizationLinkViewComponent } from '../components/profile/user-profile/view-profile/organization-link-view/organization-link-view.component';
import { SharedModule } from '../shared.module';
import { DonateButtonComponent } from './donate-button/donate-button.component';
import { EyePasswordComponent } from './eye-password/eye-password.component';
import { FilterDropDownComponent } from './filter-drop-down/filter-drop-down.component';
import { ItemsListComponent } from './items-list/items-list.component';
import { ProfileInfoComponent } from './profile-info/profile-info.component';
import { RouteTitleComponent } from './route-title/route-title.component';
import { UserBasicComponent } from './user-basic/user-basic.component';
import { UserInfoComponent } from './user-info/user-info.component';

@NgModule({
  imports: [SharedModule, SlickCarouselModule, CardsModule, PipesModule],
  declarations: [
    ProfileInfoComponent,
    EyePasswordComponent,
    FilterDropDownComponent,
    BreadcrumbNavigationComponent,
    OrganizationLinkViewComponent,
    UserBasicComponent,
    UserInfoComponent,
    CarouselComponent,
    ItemsListComponent,
    DonateButtonComponent,
    RouteTitleComponent,
    TrimOnBlurDirective,
  ],
  exports: [
    ProfileInfoComponent,
    EyePasswordComponent,
    FilterDropDownComponent,
    BreadcrumbNavigationComponent,
    OrganizationLinkViewComponent,
    UserBasicComponent,
    UserInfoComponent,
    CarouselComponent,
    ItemsListComponent,
    DonateButtonComponent,
    RouteTitleComponent,
    TrimOnBlurDirective,
  ],
})
export class ViewsModule {}
